import { useEffect, useState } from "react";
import { restGet } from "@/lib/supabaseRest";

const KEY = "wz-enabled";
let inflight: Promise<boolean> | null = null;

/**
 * Returns true only if any published widget_zone rows exist.
 * Result is cached in sessionStorage so we issue at most one query per session.
 * When false, callers should render nothing — no JS chunk for WidgetZoneImpl is loaded.
 */
export function useWidgetZonesEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem(KEY) === "1";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const cached = sessionStorage.getItem(KEY);
    if (cached === "1" || cached === "0") return;

    if (!inflight) {
      inflight = (async () => {
        // Plain PostgREST fetch — fires on first paint, must stay supabase-js-free.
        const rows = await restGet<{ id: string }[]>(
          "page_content?select=id&section_type=eq.widget_zone&is_published=eq.true&limit=1",
        );
        const has = (rows?.length ?? 0) > 0;
        try { sessionStorage.setItem(KEY, has ? "1" : "0"); } catch {}
        return has;
      })();
    }
    inflight.then((has) => { if (has) setEnabled(true); });
  }, []);

  return enabled;
}

export function clearWidgetZonesEnabledCache() {
  try { sessionStorage.removeItem("wz-enabled"); } catch {}
  inflight = null;
}
